import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  // We use a ref to track if this is the first time the app loads (e.g., Refresh)
  const isFirstRun = useRef(true);

  useEffect(() => {
    // Ensure browser native scroll restoration is enabled
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = "auto";
    }

    // --- EXCEPTION: The Menu Page ---
    // You wanted to "escape" the menu page.
    // This forces the Menu to ALWAYS start at the top, even on refresh.
    if (pathname === "/menu") {
      window.scrollTo(0, 0);
      isFirstRun.current = false;
      return;
    }

    // --- LOGIC FOR HOMEPAGE & OTHERS ---
    // If this is the first load (Refresh), we return EARLY.
    // This stops us from forcing the page to (0,0), allowing the browser
    // to put you back at the Testimonials section.
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    // If it's NOT a refresh (user clicked a link), scroll to top.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
